export default "__VITE_ASSET__fd19d615__"